import React from "react";
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

// Wrappers & Auth
import PublicWrapper from "../wrapper/PublicWrapper";
import AppWrapper from "../wrapper/AppWrapper";
import ProtectedRoute from "../auth/ProtectedRoute";

// Public Pages
import LoginPage from "../pages/LoginPage";
import CheckoutPage from "../pages/CheckoutPage";
import UnauthorizedPage from "../pages/UnauthorizedPage";
import NotFoundPage from "../pages/NotFoundPage";

// Standalone Pages
import ProfilePage from "../pages/ProfilePage";
import SettingsPage from "../pages/SettingsPage";
import CompanyPage from "../pages/CompanyPage";

const AppRoutes = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { userInfo } = useSelector((state) => state.user);

  React.useEffect(() => {
    if (userInfo) {
      // 1. Exact matches for static auth pages
      const staticAuthRoutes = ["/", "/login"];

      if (staticAuthRoutes.includes(location.pathname)) {
        const from = location.state?.from?.pathname || "/dashboard";
        navigate(from, { replace: true });
      }
    }
  }, [userInfo, location, navigate]);

  return (
    <Routes>
      {/* 1. PUBLIC ROUTES */}
      <Route element={<PublicWrapper />}>
        <Route index element={<LoginPage />} />
        <Route path="/login" element={<LoginPage />} />

        <Route path="/checkout" element={<CheckoutPage />} />
        <Route path="/unauthorized" element={<UnauthorizedPage />} />
      </Route>

      {/* 2. PROTECTED APP ROUTES (AppWrapper acts as the shell) */}
      <Route
        element={
          <ProtectedRoute>
            <AppWrapper />
          </ProtectedRoute>
        }
      >
        {/* A. Standalone Pages (Rendered via <Outlet /> in AppWrapper) */}
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/company" element={<CompanyPage />} />
        <Route path="/settings" element={<SettingsPage />} />

        {/* B. The Workspace Catch-All (For /dashboard, /users, /items, etc.) */}
        {/* We just need this so React Router doesn't throw a 404. AppWrapper handles the rendering. */}
        <Route path="/*" element={<></>} />
      </Route>

      {/* 3. 404 Route */}
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
};

export default AppRoutes;
